import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import useSkeletonTheme from '../../hooks/useSkeletonTheme';

const ConfigItemSkeleton = () => {
    const { base } = useSkeletonTheme();
    return (
        <SkeletonTheme color={base.color} highlightColor={base.highlightColor}>
            <Skeleton height={72} />
        </SkeletonTheme>
    );
};

export default ConfigItemSkeleton;
